export default __webpack_public_path__ + "static/media/IMG_6691.59416c40.59416c40.JPG";